import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ValidationMessageService } from '../../../services/validation-message.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { GrowlerComponent, GrowlerInput } from './growler.component';

export enum GrowlerType {
    DEFAULT = 'default',
    INFO = 'info',
    SUCCESS = 'success',
    WAIT = 'wait',
    ERROR = 'error',
    WARNING = 'warning',
}

@Injectable({
    providedIn: 'root',
})
export class GrowlerService
{
    constructor(
            private _snackBar: MatSnackBar,
            private _validationMessageService: ValidationMessageService,
    ) {
    }

    /**
     * @param title
     * @param message
     */
    public success(title: string, message: string): void {
        this.growlMessage(title, message, GrowlerType.SUCCESS);
    }

    /**
     * @param title
     * @param message
     */
    public error(title: string, message: string): void {
        this.growlMessage(title, message, GrowlerType.ERROR);
    }

    public fromErrorResponse(
            response: HttpErrorResponse,
            defaultMessage = 'An unexpected error occurred. Please try again later.',
    ): void {
        const message = this._validationMessageService.extractResponseErrorText(response, defaultMessage);
        this.oops(message);
    }

    /**
     * @param message
     */
    public oops(message: string): void {
        this.growlMessage('Oops!', message, GrowlerType.ERROR);
    }

    /**
     * @param title
     * @param message
     */
    public warning(title: string, message: string): void {
        this.growlMessage(title, message, GrowlerType.WARNING);
    }

    /**
     * Dispatch growl message to store
     * @param title
     * @param message
     * @param type
     */
    private growlMessage(title: string, message: string, type: GrowlerType): void {
        const data: GrowlerInput = {
            title,
            message,
            type,
            autoDismissAfter: 5000,
        };
        const snackBarOptions: MatSnackBarConfig = {
            data,
            panelClass: `growler-${type}`,
            duration: data.autoDismissAfter,
            horizontalPosition: 'left',
            verticalPosition: 'top',
        };

        this._snackBar.openFromComponent(GrowlerComponent, snackBarOptions);
    }
}
